import React from "react";
import { Modal, Form, Card, InputNumber, message } from "antd";
import Button from "./button";
import Dropdown from "./dropdown";
import colors from "../../share/constants/constants";
import { promoCodeVendor } from "../../api/user";
import { useNavigate } from "react-router-dom";

const PromoModal = ({ onCancel, onOk, text, title, id }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const dropValues = [
    {
      id: 0,
      name: "Amount",
    },
    {
      id: 1,
      name: "Percent",
    },
  ];
  const onFinish = async (values) => {
    const payload = {
      promoType: "STRIPE",
      discountAmount: values?.amount,
      isPercent: values?.percent === "0" ? false : true,
      businessId: id,
    };
    const res = await promoCodeVendor(payload);
    if (res) {
      message.success("Promo Code created successfully!");
      onOk();
      navigate(`/main/business-request-detail/${id}`);
      //   setRender(!render);
    }
  };
  const validateAmount = ({ getFieldValue }) => ({
    validator(_, value) {
      const percentSelected = getFieldValue("percent") === "1";

      if (percentSelected && value > 100) {
        return Promise.reject("Percent should not exceed 100");
      }
      return Promise.resolve();
    },
  });
  return (
    <div>
      <Modal
        open={true}
        footer={null}
        onCancel={onCancel}
        className="space-y-20"
        width="479px"
      >
        <h3>{title}</h3>
        <p>{text}</p>
        <Card className="border-2 p-2">
          <Form onFinish={onFinish} form={form}>
            <div className="grid grid-cols-3 gap-2">
              <Form.Item name="percent">
                <Dropdown
                  placeholder={"Percent"}
                  data={dropValues}
                  className={"w-12"}
                />
              </Form.Item>
              <Form.Item
                name="amount"
                rules={[
                  {
                    required: true,
                    message: "This field is required",
                  },
                  {
                    pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                    message: "Please enter a positive number",
                  },
                  validateAmount,
                ]}
              >
                <InputNumber
                  className="flex items-center w-12 h-5.4"
                  placeholder="Discount"
                  type="number"
                  controls={false}
                />
              </Form.Item>
              <Form.Item>
                <Button
                  title={"Save"}
                  color={colors.primaryBlue}
                  htmlType="submit"
                  //   onClick={onOk}
                  className="w-12"
                />
              </Form.Item>
            </div>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default PromoModal;
